import React from 'react';

import { SMPFlex, SMPImage, SMPText } from '@velinsi/smp-widgets-ui';
import { EventParticipantType, StatusType } from '../../../../../packages/types';

interface TeamScoreProps {
  status: StatusType;
  team: EventParticipantType;
}

export const TeamScore: React.FC<TeamScoreProps> = ({ team, status }) => {
  const textStyle = {
    fontSize: '$2_5',
    color: status === StatusType.FINISHED && !team.isWinner ? '$teamLostColor' : '$multiSportTextColor',
    lineHeight: '20px',
  };

  return (
    <SMPFlex css={{ width: '100%' }} justify={'spaceBetween'} align={'center'}>
      <SMPFlex css={{ mr: '$4' }}>
        {team.logo ? (
          <SMPImage css={{ mr: '$1', height: '$3', width: '$3' }} src={team.logo} alt={`Team ${team?.name}`} />
        ) : (
          <div style={{ height: '16px', width: '16px', marginRight: '4px', borderRadius: '4px', backgroundColor: '#F0F0F0' }} />
        )}
        <SMPText weight={team.isWinner ? 700 : 400} css={textStyle}>
          {team.name}
        </SMPText>
      </SMPFlex>
      <SMPText weight={team.isWinner ? 700 : 400} css={textStyle}>
        {status === StatusType.NOT_STARTED ? '-' : team.score ?? '-'}
      </SMPText>
    </SMPFlex>
  );
};
